import { Flex } from '@chakra-ui/react';
import { Button, ChevronRight, SelectValue, SelectTrigger, Select, SelectItem, SelectContent } from '@mesh.ai/rabbit';
import {
  setIsBudgetDrawerOpen,
  setIsCreateGuidelineDrawerOpen,
} from 'Deer/intent/Compensation/components/slice/compensationDrawersSlice';
import { useDispatch } from 'react-redux';
import { LabelFieldWrapper } from 'screens/admin/Reviews/ReviewProcessV2Intent/components/LabelFieldWrapper';
import { SectionWrapper } from 'screens/admin/Reviews/ReviewProcessV2Intent/components/SectionWrapper';

import { TextHeader3, TextHeader4, TextLabel, TextLabelSmall } from 'uiToolkitV1/Typography';

export const CompensationBudgetSection = () => {
  const dispatch = useDispatch();

  return (
    <SectionWrapper
      title="Budget and guidelines"
      subTitle="Outlines the allocated compensation budget and the rules for distributing it across eligible employees."
    >
      <LabelFieldWrapper label="Budget details" gridTemplateColumns="320px 1fr" gridGap={0}>
        <Flex
          flexDir="column"
          gap="8px"
          borderRadius="8px"
          border="1px solid"
          borderColor="border.EBEFF3"
          minW="440px"
          maxW="fit-content"
          overflow="hidden"
        >
          <Flex
            p="12px 12px 16px 12px"
            w="100%"
            gap="8px"
            bg="linear-gradient(180deg, #F5F7F9 0%, rgba(245, 247, 249, 0.00) 100%)"
          >
            <Flex flexDir="column">
              <TextLabel color="text.g2">% increase/employee</TextLabel>
              <TextHeader3 fontWeight="600">7.2%</TextHeader3>
            </Flex>

            <Flex flexDir="column">
              <TextLabelSmall color="text.g2" pl="18px">
                Eligible employee pay
              </TextLabelSmall>
              <Flex gap="8px">
                <TextHeader3 fontWeight="600" fontSize="20px">
                  *
                </TextHeader3>
                <TextHeader4>$100,000</TextHeader4>
              </Flex>
            </Flex>

            <Flex flexDir="column">
              <TextLabelSmall color="text.g2" pl="18px">
                Additional adjustments
              </TextLabelSmall>
              <Flex gap="8px">
                <TextHeader4 fontWeight="600">+</TextHeader4>
                <TextHeader4>$25,000</TextHeader4>
              </Flex>
            </Flex>
          </Flex>
          <Flex
            borderTop="1px solid"
            borderColor="border.EBEFF3"
            px="12px"
            py="8px"
            bg="surface.FDFDFD"
            gap="12px"
            align="center"
          >
            <Flex flex="1" gap="38px">
              <Flex gap="20px">
                <Flex flexDir="column" align="center" justify="center">
                  <TextHeader4 fontWeight="600">=</TextHeader4>
                </Flex>

                <Flex flexDir="column">
                  <TextLabel fontSize="10px" color="text.g2">
                    Total new budget
                  </TextLabel>
                  <TextHeader4>$175,000</TextHeader4>
                </Flex>
              </Flex>
              <Flex flexDir="column" justify="flex-end">
                <TextLabel color="text.g2">Effective increase: 7.8%</TextLabel>
              </Flex>
            </Flex>
            <Button
              variant="text"
              size="small"
              iconRight={ChevronRight}
              style={{ padding: '0px' }}
              onClick={() => dispatch(setIsBudgetDrawerOpen(true))}
            >
              Edit
            </Button>
          </Flex>
        </Flex>
      </LabelFieldWrapper>
      <LabelFieldWrapper label="Compensation guideline" gridTemplateColumns="320px 1fr" gridGap={0}>
        <Flex
          flexDir="column"
          gap="8px"
          background="linear-gradient(180deg, #F5F7F9 0%, rgba(245, 247, 249, 0.00) 100%)"
          borderRadius="8px"
          border="1px solid"
          borderColor="border.EBEFF3"
          p="12px 12px 16px 12px"
          w="440px"
        >
          <Select value="OPTION_1">
            <SelectTrigger style={{ textAlign: 'left', padding: '0px', paddingBottom: '10px', width: '100%' }}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent style={{ maxWidth: '440px' }}>
              <SelectItem value="OPTION_1">2025 Performance Guidelines</SelectItem>
            </SelectContent>
          </Select>
          <Flex align="center" justifyContent="space-between">
            <Button
              variant="text"
              size="small"
              iconRight={ChevronRight}
              style={{ padding: '0px' }}
              onClick={() => dispatch(setIsCreateGuidelineDrawerOpen(true))}
            >
              Create new guideline
            </Button>
            <Button
              variant="text"
              size="small"
              iconRight={ChevronRight}
              style={{ padding: '0px' }}
              onClick={() => dispatch(setIsCreateGuidelineDrawerOpen(true))}
            >
              Edit
            </Button>
          </Flex>
        </Flex>
      </LabelFieldWrapper>
      <LabelFieldWrapper label="Guideline & budget enforcement" gridTemplateColumns="320px 1fr" gridGap={0}>
        <Select defaultValue="STRICT">
          <SelectTrigger style={{ width: '440px', textAlign: 'left' }}>
            <SelectValue />
          </SelectTrigger>
          <SelectContent style={{ maxWidth: '440px' }}>
            <SelectItem value="STRICT" style={{ paddingRight: '40px', width: 'calc(100% - 8px)' }}>
              Proposals must follow guidelines, and final approvals must stay within budget.
            </SelectItem>
            <SelectItem value="GUIDELINES_FLEXIBLE" style={{ paddingRight: '40px', width: 'calc(100% - 8px)' }}>
              Proposals must follow guidelines, but approvers can go beyond the allocated budget.
            </SelectItem>
            <SelectItem value="BUDGET_FLEXIBLE" style={{ paddingRight: '40px', width: 'calc(100% - 8px)' }}>
              Proposals can exceed guidelines, but approvers must stay within budget.
            </SelectItem>
            <SelectItem value="FLEXIBLE" style={{ paddingRight: '40px', width: 'calc(100% - 8px)' }}>
              Both proposals and approvals can go beyond set guidelines and budgets.
            </SelectItem>
          </SelectContent>
        </Select>
      </LabelFieldWrapper>
    </SectionWrapper>
  );
};
